import { 
    getAllData,
    postData, 
    getDataWithParams,
    destroyData,
    downloadFile,
} from '@/store/api/method-mbkm'

const requestInit = {
    page: 1,
    show: 10,
    sortBy: null,
    sorting: null,
    search: null,
    semesterId: null,
    study_course_id: null,
    semester_id:null,
    start_date: null,
    end_date: null,
    date: [],
}
const itemInit = {
    id: null,
    date: [],
    start_date: null,
    end_date: null,
    phase: null,
    quota: null,
    min_ipk: null,
    semester_id: null,
    is_open: 0,
    semesterId: null,
}

const initialState = () => ({
    msg: null,
    status: 0,
    data: {},
    list: [],
    phase: [],
    generatePhaseInput: 0,
    request: {...requestInit},
    item: {...itemInit},
    blobData: null,
    oprecStatus: [
        {
            status: 0,
            label: 'Pendaftaran Ditutup',
            type: 'danger'
        },
        {
            status: 1,
            label: 'Menerima Pendaftaran',
            type: 'primary'
        },
    ]
})
const state = initialState
 
const getters = {
    getMsg: state => state.msg,
    getStatus: state => state.status,
    getData: state => state.data || {},
    getRequest: state => state.request,
    getItem: state => state.item,
    getOprecStatus: state => (status) => state.oprecStatus.find(x => x.status == status),
    getList: state => state.list,
    getBlobData: state => state.blobData,
    getPhaseList: state => state.phase,
    getGeneratePhase: state => state.generatePhaseInput
}

const actions = {
    resetRequest({commit}){
        commit('SET_REQUEST',{...requestInit})
    },
    resetItem({commit}){
        commit('SET_ITEM',{...itemInit})
    },
    setItem({commit}, value){
        commit('SET_ITEM',{...value})
    },
    async store({commit}, data) {
        try {
            const payload = {...data}
            delete payload.id
            const response = await postData('/oprecofassistant',payload);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async fetchData({commit, state}){
        try {
            const response = await getDataWithParams('/oprecofassistant',state.request);
            commit('SET_RESPONSE', response.data);
            commit('SET_DATA', response.data.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    // async fetchAllData({commit}){
    //     try {
    //         const response = await getAllData('/oprecofassistant/list-oprec');
    //         commit('SET_RESPONSE', response.data);
    //         commit('SET_LIST', response.data.data);
    //     } catch (err) {
    //         if(err.response){
    //             commit('SET_FAILED_MESSAGE', err.response);
    //         }else{
    //             commit('SET_FAILED')
    //         }
    //     }
    // },
    async update({commit}, data) {
        try {
            const url = `/oprecofassistant/update/${data.id}`
            const payload = {
                ...data
            }
            delete payload.id
            const response = await postData(url,payload);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async updateStatus({commit}, data) {
        try {
            const url = `/oprecofassistant/update-status/${data.id}`
            const payload = {
                ...data
            }
            delete payload.id
            const response = await postData(url,payload);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async destroy({commit}, data) {
        try {
            const url = `/oprecofassistant/${data.id}`
            const response = await destroyData(url);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    resetState({commit}){
        commit('resetState')
    },
    async downloadFile({commit }, {url, type}) 
    {
        try {
            var response = await downloadFile(url);
            commit('SET_BLOBDATA', {value: response.data,type: type});
        } catch (e) {
            if(e.response){
                commit('SET_FAILED_MESSAGE',e.response)
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async downloadFileWithDate({commit }, {url, type, data = {}}) 
    {
        try {
            var response = await downloadFile(url, data);
            commit('SET_BLOBDATA', {value: response.data,type: type});
        } catch (e) {
            if(e.response){
                commit('SET_FAILED_MESSAGE',e.response)
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async fetchPhase({commit}, semesterId){
        try {
            const response = await getAllData('/oprecofassistant/phase/'+semesterId);
            commit('SET_RESPONSE', response.data);
            commit('SET_PHASE', response.data.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },

    async generatePhase({commit},data){
        try {
            const payload = {...data}
            delete payload.id
            const response = await postData('/oprecofassistant/generate-phase',payload);
            commit('SET_GENERATE_PHASE', response.data.data.phase);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
}

const mutations = {
    SET_FAILED(state) {
        state.msg = 'Jaringan Bermasalah'
        state.status = 0
    },
    SET_FAILED_MESSAGE(state, error) {
        state.msg = error?.data?.msg || 'Jaringan Bermasalah'
        state.status = error?.data?.status || 0
    },
    SET_RESPONSE(state, response) {
        state.msg = response.msg
        state.status = response.status
    },
    SET_DATA(state, value) {
        state.data = value
    },
    SET_REQUEST(state, value){
        state.request = value
    },
    SET_ITEM(state, value){
        state.item = value
    },
    SET_BLOBDATA(state, {value, type}) {
        state.blobData = new Blob([value], { type: type })
    },
    SET_LIST(state, value){
        state.list = value
    },
    SET_PHASE(state, value){
        state.phase = value
    },
    SET_GENERATE_PHASE(state, value) {
        state.generatePhaseInput = value
    },
    resetState (state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
